import api from 'app/api';
import store from 'app/store';

export const getVenueList = async (callback) => {
  const successCallback = ({ data }) => {
    const venueList = (data || []).map((item) => ({
      ...item,
      id: item?._id,
      label: `${item?.venueName}, ${item?.venueCity}`,
    }));
    store.dispatch({ type: 'ADMIN_EVENT_CREATE:VENUE_LIST:SET', data: venueList });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/venueList`,
    {
      id: 'list-venues',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        page_no: 0,
      },
    },
  );
};

export const getCitiesList = async (callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'ADMIN_EVENT_CREATE:CITY_LIST:SET', data: (data || []).map((item) => ({ ...item, id: item?._id, label: item?.cityName })) });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/city`,
    {
      id: 'list-cities',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isAdmin: true,
      },
    },
  );
};

export const createEvent = async (payload, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.post(
    `/events`,
    {
      ...payload,
      is_secondary: true,
      is_active: true,
    },
    {
      id: 'create-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const updateEvent = async (id, payload, callback) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: 'ADMIN_EVENT_CREATE:SAVED_EVENT_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.put(
    `/events/primary/${id}`,
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const getEvent = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'ADMIN_EVENT_CREATE:EVENT_DATA:SET', data: data?.payload });

    if (callback) callback(data);
  };

  await api.get(
    `/events/${id}`,
    {
      id: 'get-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const createVenue = async (payload, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.post(
    `/venues`,
    payload,
    {
      id: 'create-venue',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};
